
import { UtilsService } from "@core/services/utils";
import { Component, ChangeDetectionStrategy, ViewEncapsulation, OnInit, OnDestroy, Input } from "@angular/core";
import { Subject } from 'rxjs';
import { vGlobal } from "@core/types/cb-global-vars";
@Component({
  selector: "text-template",
  templateUrl: "./text-template.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./text-template.component.scss"],
  exportAs: "textTemplate"
})
export class TextTemplateComponent implements OnInit, OnDestroy {
  // -----------------------------------------------------------------------------------------------------
  // @ Decorators
  // -----------------------------------------------------------------------------------------------------
  @Input() template: string;
  // -----------------------------------------------------------------------------------------------------
  /** constructor  */
  // -----------------------------------------------------------------------------------------------------
  constructor(
    private _utilS: UtilsService,
  ) { }
  // -----------------------------------------------------------------------------------------------------
  // @ Public declaration vars
  // -----------------------------------------------------------------------------------------------------
  txtRequired: string = vGlobal.required;
  messageNoFoundRegistry: string = vGlobal.messageNoFoundRegistry;
  // -----------------------------------------------------------------------------------------------------
  // @ Private declaration vars
  // -----------------------------------------------------------------------------------------------------
  private _unsubscribeAll: Subject<boolean> = new Subject();
  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  ngOnInit() { }
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(true);
    this._unsubscribeAll.complete();
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

}
